import { notEmpty } from "@product/scmp-sdk";
import { type FunctionComponent, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { seriesWidgetContent$key } from "~/queries/__generated__/seriesWidgetContent.graphql";

import { SeriesWidgetContextProvider } from "./contexts";
import { SeriesWidgetDisplay } from "./series-widget-display";

export type Props = {
  className?: string;
  reference: seriesWidgetContent$key;
};

export const SeriesWidget: FunctionComponent<Props> = ({ reference }) => {
  const article = useFragment(
    graphql`
      fragment seriesWidgetContent on Article {
        ...seriesWidgetDisplayArticle
        ...contextsSeriesWidgetContextProviderArticle
        entityId
        seriesContainer {
          series {
            ...seriesWidgetDisplaySeriesItemResult
            __typename
            ... on BaseWithApplicationAndUrlAlias {
              entityId
            }
          }
        }
      }
    `,
    reference,
  );

  const filteredSeriesItems = useMemo(
    () =>
      (article.seriesContainer?.series ?? [])
        .filter(notEmpty)
        .filter(item => item?.__typename === "Article"),
    [article.seriesContainer?.series],
  );

  const currentItemIndex = useMemo(
    () => filteredSeriesItems.findIndex(item => item?.entityId === article.entityId),
    [article.entityId, filteredSeriesItems],
  );

  return (
    <SeriesWidgetContextProvider currentItemIndex={currentItemIndex} reference={article}>
      <SeriesWidgetDisplay reference={article} seriesItemsReference={filteredSeriesItems} />
    </SeriesWidgetContextProvider>
  );
};

SeriesWidget.displayName = "SeriesWidget";
